<template>
	<div class="d-flex flex-column align-items-center justify-content-center">
		<div v-if="message" class="alert alert-success alert-dismissible fade show wd-100p shadow-sm text-center" role="alert">
			<div v-text="message"></div>
		</div>
		<div v-if="error" class="alert alert-warning alert-dismissible fade show shadow-sm text-center" :style="'width: -webkit-fill-available'" role="alert">
			<div v-html="error"></div>
		</div>

		<div class="justify-content-center">
			<div class="wd-150 wd-sm-150 mg-b-30">
				<img :src="phone" class="img-fluid" alt="">
			</div>
		</div>

		<h3 class="tx-color-01 mg-b-5 tx-center">Two Factor Authentication</h3>
		<p class="tx-color-03 tx-13 tx-center">The security of your investment is our priority. We will send a 6-digit code to your Ghanaian mobile phone number or your email. Enter the code to access your account. It may take a moment to recieve this code.</p>
		
		<form method="POST" action="/2fa" @submit.prevent="verifyToken" class="wd-100p">
			<div class="form-group">
				<label>6-digit code</label>
				<input v-model="form.token" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('token') }" name="token" placeholder="Enter 6-digit code" required autofocus>
				<has-error :form="form" field="token"></has-error>
			</div>
			<button-component :busy="form.busy" :label="'Submit'" :label-loading="buttonMessage" :button-class="'btn btn-default btn-block shadow-sm'"></button-component>
		</form>
		<div v-if="enableResend" class="tx-13 mg-t-20 tx-center">Still don't have a code? 
			<a href="#" @click.prevent="resend">Resend Code</a>
		</div>
		<div v-else class="tx-warning tx-13 mg-t-20 tx-cente">You can resend token after {{ timer }} seconds.</div>
	</div>
</template>

<script>
	import phone from '../../../img/phone.svg'

	export default {
		data: function() {
			return {
				phone,
				error: null,
				message: null,
				timer: 30,
				enableResend: true,
				interval: null,
				buttonMessage: 'Verifying...',
				form: new Form({
					token: null
				}),
				error: null
			};
		},
		watch: {
			"form.token": function(value) {
				if (value.length === 6) {
					this.verifyToken()
				}
			}
		},
		created() {
			this.resend()
		},
		methods: {
			verifyToken() {
				this.error = null;
				const { query } = this.$route
				
				this.form
					.post("/2fa")
					.then(({ data }) => {
						clearInterval(this.interval)

						if ('intended' in query) {
							window.location = '/app/dashboard' + `?intended=${encodeURIComponent(query.intended)}`;
							return
						}

						window.location.replace(data.intended);
					})
					.catch(() => {
						this.error = this.form.errors.get("error");
					});
			},
			countDown() {
				this.interval = setInterval(() => {
					if (this.timer <= 1) {
						clearInterval(this.interval);
						this.enableResend = true
						this.timer = 30
					}
					this.timer = this.timer - 1
				}, 1000);
			},
			resend() {
				this.message = null
				this.error = null
				this.buttonMessage = 'Sending OTP...'

				this.form
					.post('/api/auth/2fa/resend')
					.then(({ data: { data }}) => {
						this.message = data.message
						this.countDown()
					})
					.catch(({response}) => {
						console.log(response);
					})
			},
		},
		props: ["redirectTo"]
	};
</script>
